import { Fragment } from 'react';
import { api, qs } from '../api';
import { fmtWhen } from '../format';
import { go, withQuery } from '../router';
import { useLoad } from '../state';
import { Choice, words } from '../ui/fields';
import { Empty, Loading, PageHead } from '../ui/bits';

const SKIP = ['updated_at', 'updated_by', 'created_at'];
function Diff({ before, after }: { before?: string; after?: string }) {
  let b: Record<string, any> = {}, a: Record<string, any> = {};
  try { b = before ? JSON.parse(before) : {}; a = after ? JSON.parse(after) : {}; } catch { return null; }
  const keys = [...new Set([...Object.keys(b), ...Object.keys(a)])].filter((k) => JSON.stringify(b[k]) !== JSON.stringify(a[k]) && !SKIP.includes(k));
  return (<>
    {keys.slice(0, 8).map((k, i) => <Fragment key={k}>{i > 0 && <br />}<code>{k}</code> {b[k] !== undefined && <><s className="muted">{String(b[k] ?? '∅').slice(0, 40)}</s> </>}{String(a[k] ?? '∅').slice(0, 60)}</Fragment>)}
    {keys.length > 8 && <><br />… {keys.length - 8} more</>}
  </>);
}

export function Audit({ query }: { query: Record<string, string> }) {
  const { data, error } = useLoad(() => api('GET', `/audit?${qs({ limit: 100, entity_type: query.entity_type, action: query.action })}`), [JSON.stringify(query)]);
  const rows: any[] = data?.audit ?? [];
  return (<>
    <PageHead title="Audit" sub="Who changed what, with the before and after" />
    <form className="toolbar" key={JSON.stringify(query)} onSubmit={(ev) => { ev.preventDefault(); go(withQuery('#/audit', ev.currentTarget)); }}>
      <Choice name="action" options={words(['insert', 'update', 'transition', 'delete', 'sync', 'relay'])} value={query.action} blank="Any action" />
      <input name="entity_type" placeholder="Entity type (campaign, campaign_track, asset…)" defaultValue={query.entity_type || ''} />
      <button className="quiet">Filter</button>
    </form>
    {error ? <Empty>{error}</Empty> : !data ? <Loading /> : rows.length ? (
      <div className="table-wrap"><table><thead><tr><th>When</th><th>Who</th><th>Action</th><th>Entity</th><th>Change</th></tr></thead><tbody>
        {rows.map((r, i) => (
          <tr key={r.id ?? i}><td className="nowrap">{fmtWhen(r.at)}</td><td>{r.actor_name || 'system'}</td><td>{r.action}</td>
            <td><code>{r.entity_type}</code><span className="sub mono">{r.entity_id}</span></td>
            <td className="small">{r.note ? r.note : <Diff before={r.before_json} after={r.after_json} />}</td></tr>
        ))}
      </tbody></table></div>
    ) : <Empty>Nothing recorded.</Empty>}
  </>);
}
